


import common from './common'
import boss from './boss'
import diction from './diction'

export default {

    modules: {
        common,
        boss,
        diction,
    }
}